const { createReducer } = require('./factory');

const INITIAL_STATE = {
  data: {},
  didInvalidate: false,
  fetchingInProgressSince: null,
  lastSuccessfulFetch: null,
  lastFailedFetch: null,
  lastErrorMessage: null,
};

const FETCH_SUCCESSFUL = 'FETCH_LEGAL_DATA_APP_SUCCESSFUL';

const LegalDataAppReducer = createReducer('LEGAL_DATA_APP', {
  minUpdate: 1000 * 60 * 60,
  fetchTimeout: 1000 * 30,
  extendedReducer: {
    [FETCH_SUCCESSFUL]: (state, action) => ({
      ...state,
      fetchingInProgressSince: null,
      lastSuccessfulFetch: action.timestamp,
      fetchPromise: null,
      data: action.data,
      versionCode: action.versionCode,
      didInvalidate: false,
    }),
  },
  initialState: INITIAL_STATE,
  invalidateActions: ['SET_API_URL', 'SET_LANGUAGE'],
});

LegalDataAppReducer.fetchSuccessful = ({ versionCode, data }) => ({
  type: FETCH_SUCCESSFUL,
  data,
  versionCode,
  timestamp: Date.now(),
});

module.exports = {
  legalApp: LegalDataAppReducer,
};
